import React, { useState, useEffect } from 'react';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import SelectModal from './SelectModal';

const DatePickOverlay = ({ isVisible, onClose, onSelect, initialDate }) => {
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedDay, setSelectedDay] = useState(new Date().getDate());

    useEffect(() => {
        if (initialDate) {
            const date = new Date(initialDate);
            setSelectedYear(date.getFullYear());
            setSelectedMonth(date.getMonth());
            setSelectedDay(date.getDate());
        }
    }, [initialDate]);

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear + i);
    const months = [
        '1월', '2월', '3월', '4월', '5월', '6월',
        '7월', '8월', '9월', '10월', '11월', '12월'
    ];

    const getDaysInMonth = (year, month) => {
        return new Date(year, month + 1, 0).getDate();
    };

    const daysInMonth = getDaysInMonth(selectedYear, selectedMonth);
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    const handleConfirm = () => {
        const date = new Date(selectedYear, selectedMonth, selectedDay, 9);
        const formattedDate = date.toISOString().split('T')[0];
        onSelect(formattedDate);
        onClose();
    };

    const isToday = (day) => {
        const now = new Date();
        const koreaTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
        return selectedYear === koreaTime.getFullYear() &&
               selectedMonth === koreaTime.getMonth() &&
               day === koreaTime.getDate();
    };

    const isPastDate = (day) => {
        const now = new Date();
        const koreaTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
        const todayStart = new Date(koreaTime.getFullYear(), koreaTime.getMonth(), koreaTime.getDate());
        const selectedDate = new Date(selectedYear, selectedMonth, day);
        return selectedDate < todayStart;
    };

    return (
        <SelectModal
            isVisible={isVisible}
            onClose={onClose}
            title="날짜 선택"
            onConfirm={handleConfirm}
        >
            {/* 년도 선택 */}
            <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                    <button
                        onClick={() => setSelectedYear(prev => Math.max(prev - 1, currentYear))}
                        className="p-2 active:bg-gray-100 rounded-full"
                        disabled={selectedYear <= currentYear}
                    >
                        <IoChevronBack size={20} className={selectedYear <= currentYear ? 'text-gray-300' : 'text-gray-600'} />
                    </button>
                    <span className="text-lg font-medium">{selectedYear}년</span>
                    <button
                        onClick={() => setSelectedYear(prev => Math.min(prev + 1, currentYear + 4))}
                        className="p-2 active:bg-gray-100 rounded-full"
                        disabled={selectedYear >= currentYear + 4}
                    >
                        <IoChevronForward size={20} className={selectedYear >= currentYear + 4 ? 'text-gray-300' : 'text-gray-600'} />
                    </button>
                </div>
            </div>

            {/* 월 선택 */}
            <div className="mb-4">
                <div className="grid grid-cols-4 gap-2">
                    {months.map((month, index) => (
                        <button
                            key={index}
                            onClick={() => setSelectedMonth(index)}
                            className={`p-2 rounded-lg text-sm ${
                                selectedMonth === index
                                    ? 'bg-amber-500 text-white'
                                    : 'bg-gray-100 active:bg-gray-200'
                            }`}
                        >
                            {month}
                        </button>
                    ))}
                </div>
            </div>

            {/* 일 선택 */}
            <div>
                <div className="grid grid-cols-7 gap-1">
                    {days.map((day) => (
                        <button
                            key={day}
                            onClick={() => setSelectedDay(day)}
                            disabled={isPastDate(day)}
                            className={`p-2 rounded-lg text-sm ${
                                selectedDay === day
                                    ? 'bg-amber-500 text-white'
                                    : isPastDate(day)
                                    ? 'text-gray-300 cursor-not-allowed'
                                    : isToday(day)
                                    ? 'bg-blue-100 text-blue-600 active:bg-blue-200'
                                    : 'active:bg-gray-100'
                            }`}
                        >
                            {day}
                        </button>
                    ))}
                </div>
            </div>
        </SelectModal>
    );
};

export default DatePickOverlay;
